import { Col, Row, Spin, Divider } from 'antd';
import { BaseButton } from 'components/UI/BaseButton';
import PropType from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TIME_TYPE, UNIT_TYPE } from 'util/config/constant';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import MachineTotalCleaning from './components/MachineTotalCleaning';
import MachineUtilisationCleaning from './components/MachineUtilisationCleaning';
import * as operation from './state/operation';
import * as selector from './state/selector';
import { GROUP_BY } from './util/constant';

const MachineCleaningArea = ({ id }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MACHINE_DETAILS);
  const [timeMachineUtilisation, setTimeMachineUtilisation] = useState(
    TIME_TYPE.Year
  );
  const [unitMachineCleaningArea, setUnitMachineCleaningArea] = useState(
    UNIT_TYPE.hours
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      operation.fetchMachineCleaningAreaTotalByAll({
        machineId: id
      })
    );
  }, [dispatch, id]);
  useEffect(() => {
    switch (timeMachineUtilisation) {
      case TIME_TYPE.Year: {
        dispatch(operation.fetchMachineCleaningAreaYear({ machineId: id }));
        dispatch(
          operation.fetchMachineCleaningAreaTotalByTime({
            machineId: id,
            groupBy: GROUP_BY.year
          })
        );
        break;
      }
      case TIME_TYPE.Past6Months: {
        dispatch(
          operation.fetchMachineCleaningAreaPast6Months({ machineId: id })
        );
        dispatch(
          operation.fetchMachineCleaningAreaTotalByTime({
            machineId: id,
            groupBy: GROUP_BY.past6Months
          })
        );
        break;
      }
      case TIME_TYPE.Month: {
        dispatch(operation.fetchMachineCleaningAreaMonth({ machineId: id }));
        dispatch(
          operation.fetchMachineCleaningAreaTotalByTime({
            machineId: id,
            groupBy: GROUP_BY.month
          })
        );
        break;
      }
      case TIME_TYPE.Week: {
        dispatch(operation.fetchMachineCleaningAreaWeek({ machineId: id }));
        dispatch(
          operation.fetchMachineCleaningAreaTotalByTime({
            machineId: id,
            groupBy: GROUP_BY.week
          })
        );
        break;
      }
      default: {
        break;
      }
    }
  }, [dispatch, timeMachineUtilisation, id]);

  const handleUnitMachineCleaningArea = (value) => {
    setUnitMachineCleaningArea(value);
  };

  const handleTimeMachineUtilisation = (value) => {
    setTimeMachineUtilisation(value);
  };

  const { machineCleaningInfo } = useSelector((state) => ({
    machineCleaningInfo: selector.selectMachineCleaningAreaInfo(state)
  }));

  const renderFilterMachineUtilisation = () => {
    return (
      <div className="machine-cleaningarea-filter-time">
        <span
          className={
            timeMachineUtilisation === TIME_TYPE.Year ? 'active_title' : ''
          }
          onClick={() => handleTimeMachineUtilisation(TIME_TYPE.Year)}
          aria-hidden="true"
          data-testid="time-year">
          {t('cleaningAreaPanel.thisYear')}
        </span>
        <Divider type="vertical" />
        <span
          className={
            timeMachineUtilisation === TIME_TYPE.Past6Months
              ? 'active_title'
              : ''
          }
          onClick={() => handleTimeMachineUtilisation(TIME_TYPE.Past6Months)}
          aria-hidden="true"
          data-testid="half-year">
          {t('cleaningAreaPanel.sixMonths')}
        </span>
        <Divider type="vertical" />
        <span
          className={
            timeMachineUtilisation === TIME_TYPE.Month ? 'active_title' : ''
          }
          onClick={() => handleTimeMachineUtilisation(TIME_TYPE.Month)}
          aria-hidden="true"
          data-testid="time-month">
          {t('cleaningAreaPanel.thisMonth')}
        </span>
        <Divider type="vertical" />
        <span
          className={
            timeMachineUtilisation === TIME_TYPE.Week ? 'active_title' : ''
          }
          onClick={() => handleTimeMachineUtilisation(TIME_TYPE.Week)}
          aria-hidden="true"
          data-testid="time-week">
          {t('cleaningAreaPanel.thisWeek')}
        </span>
      </div>
    );
  };
  return (
    <Row className="machine-cleaningarea-details">
      <Col
        md={18}
        lg={18}
        sm={24}
        className="machine-cleaningarea-details-utilisation">
        <Spin spinning={machineCleaningInfo.isLoadingList}>
          {renderFilterMachineUtilisation()}
          <MachineUtilisationCleaning
            data={machineCleaningInfo.list}
            unit={unitMachineCleaningArea}
            time={timeMachineUtilisation}
            isLoading={machineCleaningInfo.isLoadingList}
          />
        </Spin>
      </Col>
      <Col md={6} lg={6} sm={24} className="machine-cleaningarea-details-total">
        <Spin
          spinning={
            machineCleaningInfo.isLoadingTotalByAll ||
            machineCleaningInfo.isLoadingTotalByTime
          }>
          <BaseButton
            className={`machine-cleaningarea-btn ${
              unitMachineCleaningArea === UNIT_TYPE.cleanedSquareMeter
                ? 'base-yellow-btn'
                : ''
            }`}
            htmlType="submit"
            onClick={() =>
              handleUnitMachineCleaningArea(UNIT_TYPE.cleanedSquareMeter)
            }>
            {t('cleaningAreaPanel.cleanedAreaButton')}
          </BaseButton>
          <br />
          <BaseButton
            className={`machine-operating-btn ${
              unitMachineCleaningArea === UNIT_TYPE.hours
                ? 'base-yellow-btn'
                : ''
            }`}
            htmlType="submit"
            onClick={() => handleUnitMachineCleaningArea(UNIT_TYPE.hours)}>
            {t('cleaningAreaPanel.operatingHoursButton')}
          </BaseButton>
          <MachineTotalCleaning
            unit={unitMachineCleaningArea}
            total={machineCleaningInfo.total}
            totalByTime={machineCleaningInfo.totalByTime}
            time={timeMachineUtilisation}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default MachineCleaningArea;

MachineCleaningArea.propTypes = {
  id: PropType.string.isRequired
};
